import BaseComponentController from '../../../../components/base-component.controller';

class GiftRecipientsComponentController  extends BaseComponentController {
    constructor(_, componentRegistryService, $q) {
        super(_, componentRegistryService, $q);
        this._ = _;
        this.componentRegistryService = componentRegistryService;
        this.recipients = [];
        this.vm = {
            errors:[],
            isValid: false
        };
    }

    init() {
        if (this.model) {
            this.recipients = this.model;
        }   
    }
 
    validate(isRequired = true) {
        if (this.readonly) {
            return true;
        }
        let isValid = this.recipients.length > 0; 
        if (!isValid) {
            this.vm.errors = [`Please add a recipient`];
            this.vm.isValid = false;
        }
        return isValid;
    }

    validateAsync() {
        return this.validate(this.required);
    }  

    addRecipient(recipient) {
        if (!this._.find(this.recipients, (r) => { return r.curtinId === recipient.curtinId } )) {
            this.recipients.push(recipient);
            this.clearError();
        }
        this.updateModel(this.recipients);
    }
    
    removeRecipient(recipientId) {
        this.recipients = this._.filter(this.recipients, (r) => { return r.curtinId !== recipientId });
        this.updateModel(this.recipients);
    }

    updateModel(recipients) {
        this.model = recipients;
    }

    clearError() {
        if (this.vm.errors.length > 0) {
            this._.remove(this.vm.errors, (error) => { return error === `Please add a recipient` });
            if(this.vm.errors.length === 0) {
                this.vm.isValid = true;
            }
        }
    }
}

GiftRecipientsComponentController.$inject = ['_', 'componentRegistryService', '$q'];

export default  {
bindings: {
    readonly: '<',
    modelName:'@',
    required: '<'
},
templateUrl: 'app/disclose/gift/components/gift-recipients/gift-recipients.html',
controller: GiftRecipientsComponentController
};


// WEBPACK FOOTER //
// ./app/disclose/gift/components/gift-recipients/gift-recipients.component.js